import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map, Observable, tap, throwError } from 'rxjs';
import { RestService } from 'src/app/services/rest.service';
import { detailsAdapter } from './new-details.adapter';
import { DebugService } from 'src/app/services/debug.service';
import { StatisticsService } from 'src/app/services/statistics.service';
import { AppDataService } from "src/app/services/appData.service";
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { TranslateService } from '@ngx-translate/core';
import Swal from'sweetalert2';
import { CustomRouteService } from '../custom-route/services';

@Injectable({ providedIn: 'root'})

export class DetailsService {
    private http = inject(HttpClient);
    private router = inject(Router);
    private rest = inject(RestService);
    private appData = inject(AppDataService);
    private stats = inject(StatisticsService);
    private debugService = inject(DebugService);
    private translate = inject(TranslateService);
    private isModal = signal(false);
    private pointsData: any = [];
    private eventsData: any = [];
    public itemDetails = signal(null);
    private _bottomSheet = inject(MatBottomSheet);
    private _customRouteService = inject(CustomRouteService);
    
    // TODO. USARLO PARA EL ENDPOINT DE DETAIL COMO PARAM
    private _routeToken = this._customRouteService.token;

    setIsModal(value){
      this.isModal.set(value);
    }

    resetItemDetails(){
      this.itemDetails.set(null)
    }

    getEventDetailsServiceSignal(id: string) {
      if (this.eventsData?.[id]){
        this.debugService.info('Loading event cache data...', '[DetailesService]');
        this.setEvent(this.eventsData[id]);
        return;
      }

      return this.getEventDetails(id).pipe(
        map((response: any) => {
          this.debugService.debug(response, '[DetailesService] Events API');
          return detailsAdapter(response)
        }),
        catchError((error: HttpErrorResponse) => {
          this.handleNotFound(error);
          return throwError(() => new Error('HTTP request failed', { cause: error }));
        }))
        .subscribe((response: any) => {
          this.debugService.debug(response, '[DetailesService] Events API Mapped');
          this.eventsData[id] = response;
          this.setEvent(response);
        });
    }
    
    getEventDetails(id: string): Observable<any> {
      const url = `${this.rest.apiUrlBase}/api/get-event-app-details/${id}`;
      return this.http.get<any>(url).pipe(
        tap((response: any) => {
          if (response.error)
            throw new HttpErrorResponse({error: response.error, status: 404, statusText: 'Not Found'});
        }),
        catchError((error: HttpErrorResponse) => {
          throw new HttpErrorResponse({error: error, status: 404, statusText: 'Not Found'});
        })
      );
    }

    setEvent(item){
      this.itemDetails.set(item);
      this.stats.addEvent(item.id);
      // this.increaseEventsVisits(item.id);
    }
  
    getPointDetailsServiceSignal(id: string) {
      if (this.pointsData?.[id]){
        this.debugService.info('Loading point cache data...', '[DetailesService]');
        this.setPoint(this.pointsData[id]);
        return;
      }

      return this.getPointDetails(id)
        .pipe(
          map((response: any) => {
            this.debugService.debug(response, '[DetailesService] Point API');
            return detailsAdapter(response)
          }),
          catchError((error: HttpErrorResponse) => {
            this.handleNotFound(error);
            return throwError(() => new Error('HTTP request failed', { cause: error }));
          }))
        .subscribe((response: any) => {
          this.debugService.debug(response, '[DetailesService] Point API Mapped');
          this.pointsData[id] = response;
          this.setPoint(response);
        });
    }

    setPointData(item){
      this.pointsData[item.id] = item;
    }

    setEventData(item){
      this.eventsData[item.id] = item;
    }
    
    getPointDetails(id: string): Observable<any> {
      const url = `${this.rest.apiUrlBase}/api/get-point-app-details/${id}`;
      return this.http.get<any>(url).pipe(
        tap((response: any) => {
          if (response.error)
            throw new HttpErrorResponse({error: response.error, status: 404, statusText: 'Not Found'});
        }),
        catchError((error: HttpErrorResponse) => {
          throw new HttpErrorResponse({error: error, status: 404, statusText: 'Not Found'});
        })
      );
    }
      
    setPoint(item){
      this.itemDetails.set(item);
      this.stats.addPoint(item.id);
      // this.increasePointVisits(item.id);
    }
    
    handleNotFound(error: HttpErrorResponse) {
      // if (error.status === 404 || error.status === 500) 
      if (this.isModal()){
        // this.modalControllerl.dismiss();
        Swal.fire({
          title: '',
          text: this.translate.instant('Error al obtener información'),
          icon: 'error',
          showCancelButton: false,
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        }).then(() => {
          this._bottomSheet?.dismiss();
        })
        return;
      }
      this.router.navigateByUrl('not-found');
    }

    increasePointVisits(id){
      this.rest.increaseVisitsPoint(id).subscribe((response) => {
        const point = this.appData?.dataHome?.homePoints?.find((point) => point?.items?.find(p => p.id == id))?.items?.find(e => e.id == id)
        if (!point) 
          return;

        point.num_clicks++;
      });
    }

    increaseEventsVisits(id){
      this.rest.increaseVisitsPoint(id).subscribe((response) => {
        const event = this.appData?.dataHome?.homePoints?.find((point) => point?.events?.find(p => p.id == id))?.events?.find(e => e.id == id);
        if (!event) 
          return;

        event.num_clicks++;
      });
    }
}